import {
    FETCH_EMAIL_MANAGEMENT_REQUEST,
    FETCH_EMAIL_MANAGEMENT_SUCCESS,
    FETCH_EMAIL_MANAGEMENT_FAILURE,
    FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST,
    FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS,
    FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE,
    CREATE_EMAIL_MANAGEMENT_REQUEST,
    CREATE_EMAIL_MANAGEMENT_SUCCESS,
    CREATE_EMAIL_MANAGEMENT_FAILURE,
    RESET_CREATE_EMAIL_MANAGEMENT,
    UPDATE_EMAIL_MANAGEMENT_REQUEST,
    UPDATE_EMAIL_MANAGEMENT_SUCCESS,
    UPDATE_EMAIL_MANAGEMENT_FAILURE,
    DELETE_EMAIL_MANAGEMENT_REQUEST,
    DELETE_EMAIL_MANAGEMENT_SUCCESS,
    DELETE_EMAIL_MANAGEMENT_FAILURE,
} from '../actions/emailManagementActions';

const initialState = {
    emailManagement: {
        loading: false,
        error: null,
        data: null,
    },
    selectedEmailManagement: {
        data: null,
        loading: false,
        error: null,
    },
    create: {
        loading: false,
        error: null,
        success: false,
    },
    update: {
        loading: false,
        error: null,
        success: false,
    },
    delete: {
        loading: false,
        error: null,
        success: false,
        message: null,
    },
};

const emailManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_EMAIL_MANAGEMENT_REQUEST:
            return {
                ...state,
                emailManagement: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_EMAIL_MANAGEMENT_SUCCESS:
            return {
                ...state,
                emailManagement: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_EMAIL_MANAGEMENT_FAILURE:
            return {
                ...state,
                emailManagement: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case FETCH_EMAIL_MANAGEMENT_BY_ID_REQUEST:
            return {
                ...state,
                selectedEmailManagement: {
                    loading: true,
                    error: null,
                    data: null,
                },
            };

        case FETCH_EMAIL_MANAGEMENT_BY_ID_SUCCESS:
            return {
                ...state,
                selectedEmailManagement: {
                    loading: false,
                    error: null,
                    data: action.payload,
                },
            };

        case FETCH_EMAIL_MANAGEMENT_BY_ID_FAILURE:
            return {
                ...state,
                selectedEmailManagement: {
                    loading: false,
                    error: action.payload,
                    data: null,
                },
            };

        case CREATE_EMAIL_MANAGEMENT_REQUEST:
            return {
                ...state,
                create: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_EMAIL_MANAGEMENT_SUCCESS:
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: true,
                },
            };

        case CREATE_EMAIL_MANAGEMENT_FAILURE:
            return {
                ...state,
                create: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case RESET_CREATE_EMAIL_MANAGEMENT:
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: false,
                },
            };

        case UPDATE_EMAIL_MANAGEMENT_REQUEST:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case UPDATE_EMAIL_MANAGEMENT_SUCCESS:
            // La réponse de l'API est directement l'objet email_management
            const updatedEmailManagement = action.payload.email_management || action.payload;
            const updatedEmailManagementId = updatedEmailManagement?.email_management_id;

            // Mettre à jour l'item dans la liste si elle existe
            let updatedData = state.emailManagement.data;
            if (updatedData && updatedEmailManagementId) {
                // Gérer différentes structures de données possibles
                const records = updatedData?.data?.records || updatedData?.records;
                if (Array.isArray(records)) {
                    const updatedRecords = records.map((record) => {
                        const recordEmailMgmtId = record.email_management?.email_management_id;
                        if (recordEmailMgmtId === updatedEmailManagementId) {
                            return { ...record, email_management: updatedEmailManagement };
                        }
                        return record;
                    });

                    // Reconstruire la structure de données selon la structure existante
                    if (updatedData.data) {
                        updatedData = {
                            ...updatedData,
                            data: {
                                ...updatedData.data,
                                records: updatedRecords,
                            },
                        };
                    } else if (updatedData.records) {
                        updatedData = {
                            ...updatedData,
                            records: updatedRecords,
                        };
                    }
                }
            }

            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                },
                emailManagement: {
                    ...state.emailManagement,
                    data: updatedData,
                },
            };

        case UPDATE_EMAIL_MANAGEMENT_FAILURE:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case DELETE_EMAIL_MANAGEMENT_REQUEST:
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                    message: null,
                },
            };

        case DELETE_EMAIL_MANAGEMENT_SUCCESS: {
            const deletedId = action.payload?.email_management_id || action.payload;
            const records = state.emailManagement.data?.data?.records
                || state.emailManagement.data?.records;
            let updatedData = state.emailManagement.data;
            if (Array.isArray(records) && deletedId) {
                const filteredRecords = records.filter(
                    (record) => record.email_management?.email_management_id !== deletedId
                );
                if (state.emailManagement.data?.data?.records) {
                    updatedData = {
                        ...state.emailManagement.data,
                        data: {
                            ...state.emailManagement.data.data,
                            records: filteredRecords,
                        },
                    };
                } else {
                    updatedData = {
                        ...state.emailManagement.data,
                        records: filteredRecords,
                    };
                }
            }
            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                    message: action.payload?.message || null,
                },
                emailManagement: {
                    ...state.emailManagement,
                    data: updatedData,
                },
            };
        }

        case DELETE_EMAIL_MANAGEMENT_FAILURE:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload,
                    success: false,
                    message: null,
                },
            };

        default:
            return state;
    }
};

export default emailManagementReducer;

